import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContex } from '../context API/UserContext'

const AddBlog = () => {
  const [highlight,setHighlight]=useState("")
  const [desc,setDesc]=useState("")
  const[imageb,setImage]=useState()
  const[date,setDate]=useState("")
  const formData=new FormData()
   const [userData, setUserData] = useContext(UserContex);
  const navigate=useNavigate()
  formData.append("highlight",highlight)
  formData.append("desc",desc)
  formData.append("imageb",imageb)
  formData.append("date",date)
  // console.log(Date().toString().split())
  const handlesubmit=(e)=>{
    e.preventDefault()
    axios.post("https://back.waratechnology.com/api/blog/setblog",formData)
    .then((res)=>{
      console.log(res.data.data)
navigate("/blog")
    })
    .catch((err)=>{
       alert(err.response.data.msg);
      console.log(err)

    })
  }
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className="uppercase font-bold text-2xl">Add Blog</h1>
        </div>
        <form
        onSubmit={handlesubmit}
        >
          <div className="flex my-4">
            <label className="font-bold mr-2">Highlight</label>
            <input
              placeholder="highlight"
              type="text"
              className="w-full  pl-2 h-12 md:h-8 border border-gray-300 rounded-2xl"
              onChange={(e) => setHighlight(e.target.value)}
            />
          </div>
          <div className="flex my-4">
            <label className=" font-bold mr-2">Description</label>
            <textarea
              rows="5"
              cols="20"
              onChange={(e) => setDesc(e.target.value)}
              placeholder="description"
              className="w-full pl-2 border border-gray-300 rounded-2xl "
            ></textarea>
          </div>

          <div className="flex my-4">
            <label className=" font-bold mr-2">Image</label>
            <input
              type="file"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </div>

          <div className="flex my-4">
            <label className=" font-bold mr-2">Date</label>
            <input
              // placeholder="description"
              type="date"
              className="w-full h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setDate(e.target.value)}
            />
          </div>

          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-full"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddBlog
